import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { add, startOfDay } from 'date-fns';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  constructor(private http: HttpClient) {}

  public getBulkExportUrl$(startTime: Date, endTime: Date): Observable<string[]> {
    const realStartTime = startOfDay(startTime);
    const realEndTime = add(startOfDay(endTime), { days: 1 }); // the day after at 00:00:00
    return this.http
      .post<{ urls: string[] }>(`${environment.api}/v2/admin/excel_export`, {
        startTime: realStartTime.toISOString(),
        endTime: realEndTime.toISOString(),
      })
      .pipe(map((response) => response?.urls));
  }

  public getCompanyTaxExportUrl$(startTime: Date, endTime: Date): Observable<string> {
    const realStartTime = startOfDay(startTime);
    const realEndTime = add(startOfDay(endTime), { days: 1 }); // the day after at 00:00:00
    return this.http
      .post<{ url: string }>(`${environment.api}/v2/admin/tax_export`, {
        startTime: realStartTime.toISOString(),
        endTime: realEndTime.toISOString(),
      })
      .pipe(map((response) => response?.url));
  }
}
